<template>
  <div id="ContactProfile">
    <div
      id="SearchContact"
      class="panel panel-default"
      style="margin-bottom:unset"
      v-if="!$store.state.chat.isMobileMode"
    >
      <div class="panel-heading web-ui"></div>
      <div class="panel-body">
        <div class="row">
          <div class="col-lg-12">
            <input
              type="text"
              @keyup.enter="sendSearch"
              @keyup.exact="chekSearch"
              name="search"
              class="search-ui"
              placeholder="Search for customers name..."
              autocomplete="off"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="search-contact" v-if="$store.state.chat.isMobileMode">
      <input
        type="text"
        @keyup.enter="sendSearch"
        @keyup.exact="chekSearch"
        name="search"
        class="search-ui"
        placeholder="Search for customers name..."
        autocomplete="off"
      />
    </div>
    <div class="header-group">Profile</div>
    <div class="uk-card uk-card-default">
      <div class="uk-card-header">
        <div class="uk-grid-small uk-flex-middle" uk-grid>
          <div class="uk-width-auto">
            <img
              width="64"
              height="64"
              v-lazy="
                  `https://cdnx.softsq.com/thumb/unsafe/84x84/${encodeURIComponent(
                    encodeURIComponent(profile.urlProfile),
                  )}`
                "
              class="uk-border-circle"
              data-src="holder.js/64x64"
              style="width: 54px; height: 54px;"
              data-holder-rendered="true"
            />
          </div>
          <div class="uk-width-expand">
            <h3
              class="uk-card-title uk-margin-remove-bottom uk-margin-remove-top"
            >{{ profile.nickName }}</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="header-group">Contact Customers</div>
    <scroll-box
      class="contact-showScoll"
      @on-scroll-bottom="loadMoreCustomer"
      v-bind:style="{
        overflowY: searchCustomers.length > 8 ? 'scroll' : 'none',
      }"
    >
      <ul
        class="list-group"
        id="listContact"
        :class="{ 'on-mobile':  $store.state.chat.isMobileMode }"
        v-loading="customersLoading"
      >
        <li
          v-for="item in searchCustomers"
          :key="item.custId"
          @click="$store.dispatch('contact/setActiveContactCustumer', item)"
          class="list-group-item"
        >
          <div class="uk-grid-small uk-flex-middle" uk-grid>
            <div class="uk-width-auto">
              <a href="#">
                <img
                  width="64"
                  height="64"
                  v-lazy="
                    `https://cdnx.softsq.com/thumb/unsafe/84x84/${encodeURIComponent(
                      encodeURIComponent(item.custImage),
                    )}`
                  "
                  class="uk-border-circle"
                  data-src="holder.js/64x64"
                  style="width: 54px; height: 54px;"
                  data-holder-rendered="true"
                />
              </a>
            </div>
            <div class="uk-width-expand">
              <h4
                class="uk-margin-remove-bottom uk-margin-remove-top"
              >{{ item.custNameNew == '' ? item.custName : item.custNameNew }}</h4>
            </div>
          </div>
        </li>
      </ul>
    </scroll-box>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DialogStatus } from '../store';
import { Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import ScrollBox from './ScrollBox.vue';

export default {
  name: 'ListContact',
  data() {
    return {
      search: '',
      loading: false,
      onScroll: new Subject(),
      subscriptions: [],
    };
  },
  components: {
    ScrollBox,
  },
  computed: {
    searchCustomers: function() {
      let customers = [...this.customers];
      return customers;
    },
    ...mapGetters('profile', ['profile']),
    ...mapGetters('chat', [
      'customers',
      'searchContactCustomer',
      'customersLoading',
      'customersLoadMoreLoading',
    ]),
    ...mapGetters('contact', ['customerContact']),
    ...mapGetters(['dialogStatus']),
  },
  methods: {
    sendSearch: function({ target }) {
      this.search = target.value;
      if (this.search != '') {
        this.$store.dispatch('chat/searchContact', this.search);
      } else {
        this.$store.dispatch('chat/loadCustomers');
        this.$store.dispatch('chat/clearSearchContact');
      }
    },
    chekSearch(e) {
      if (!e.target.value) {
        this.search = '';
        this.$store.dispatch('chat/loadCustomers');
        this.$store.dispatch('chat/clearSearchContact');
      }
    },
    loadMoreCustomer() {
      this.onScroll.next(this.$store.state.chat.lastCustomer._id);
    },
  },
  created() {
    if (this.dialogStatus == DialogStatus.CLOSE) {
      this.$destroy();
      return false;
    }
    this.$store.dispatch('chat/connect').then(() => {
      if (!this.customers.length) {
        this.$store.dispatch('chat/loadCustomers');
      }
    });
    this.$store.dispatch('chat/setActiveChatCustumer', null);
    const subscribeScroll = this.onScroll
      .pipe(distinctUntilChanged())
      .subscribe({
        next: () => {
          this.$store.dispatch('chat/loadMoreCustomer', this.search);
        },
      });

    this.subscriptions.push(subscribeScroll);
  },
};
</script>
<style>
@media (max-width: 767px) {
  #ContactProfile {
    border-right: 1px solid #ddd;
  }
}

.list-group-item {
  border-right: unset;
}

.list-group-item:last-child {
  border-bottom-right-radius: unset;
  border-bottom-left-radius: unset;
}

.list-group-item:first-child {
  border-bottom-right-radius: unset;
  border-bottom-left-radius: unset;
  border-top-right-radius: unset;
  border-top-right-radius: unset;
}

#SearchContact.panel {
  border-radius: unset;
  -webkit-box-shadow: unset;
  box-shadow: unset;
  border-right: unset;
}
.list-group {
  margin-bottom: unset !important;
}
.contact-showScoll {
  height: 118vh;
  display: block;
}
.contact-showScoll::-webkit-scrollbar-track {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.contact-showScoll::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
}

.contact-showScoll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #00978b;
}
.header-group {
  font-size: 18px;
  color: #fff;
  background: #00978b;
  padding: 10px 0px 10px 15px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/ListContact.vue